import Vue from 'vue';
import { routers } from './router';
import Router from 'vue-router';
// import store from "../pages/store";
import DictFactory from '../enums/dictFactory';
// import PublicApi from "../util/publicApi";
// import {Toast} from "../util/toast";
import iView from 'lb-iview';
import routerInstance from './routerInstance';
import EnumFactory from '../enums/enumFactory';
import EntityFactory from '../enums/entityFactory';
import { modalRemove } from '../util/vueExtend';
import store from 'src/pages/store';
let iview: any = iView;

Vue.use(Router);

// let index = 0
routerInstance.addRoutes(routers);
routerInstance.beforeEach(async (to, from, next) => {
    console.log('to', to);
    // index++
    iview.LoadingBar.start();
    if (to.name === 'login' || to.name === 'error-404') {
        next();
    } else {
        // if(index===1) {
        //     // await refreshToken();
        // }
        // // 防止从特殊页面进入下一个页面  不将前一个页面的缓存清除
        // let {authority} = await PublicApi.getAuthorityMenu()
        store.commit('layout/saveCache', to.meta.cache||[])
        console.log('to.meta.cache', to.meta.cache)
        next();
        // try {
        // 	

        // 	if (authority[to.path] && authority[to.path].permission === false) {
        // 		Toast.error('您没有该页面的使用权限')
        // 		next({
        // 			name: 'login',
        // 		})
        // 		return
        // 	}
        // 	to.meta.authority = authority[to.path]
        // 	next()
        // } catch (e) {
        // 	next({
        // 		name: 'login',
        // 	})
        // }
    }
});

routerInstance.afterEach(to => {
    iview.LoadingBar.finish();
    // 清除字典缓存
    DictFactory.clearCache();
    EnumFactory.clearCache();
    EntityFactory.clearCache();
    // 防止路由在一些特殊情况下切换  模态框却没有关闭
    iview.Modal.remove();
    modalRemove();
    // let doms = document.getElementsByClassName('v-transfer-dom');
    //
    // for(let i=0;i<doms.length;i++){
    //
    // 	console.log('doms', doms[i].remove());
    //
    //
    // }
});
export const router = routerInstance;
